import React from 'react';
import PropTypes from 'prop-types';
import { useClassName } from 'common/hooks';
import { useDateBadge } from '../hooks';
import './styles/date-badge.less';

const DateBadge = ({ schedule }) => {
  const classNames = useClassName('date-badge');
  const { badgeText, variant } = useDateBadge(schedule);

  if (!badgeText) return null;

  return <div className={classNames(['badge', variant])}>{badgeText}</div>;
};

DateBadge.propTypes = {
  schedule: PropTypes.array.isRequired,
};

export default DateBadge;
